import React from 'react';

import { Typography } from 'shared/Houston';
import { enOrderBumpStatus } from 'types/enums';

import createUseStyle from '@eduzz/houston-styles/createUseStyles';
import useHoustonTheme from '@eduzz/houston-styles/useHoustonTheme';

import { Container } from './styles';

interface IProps {
  type: enOrderBumpStatus;
  text: string;
}

const UseGetColor = (type: enOrderBumpStatus) => {
  const theme = useHoustonTheme();

  const success = theme.feedbackColor.positive.pure;
  const error = theme.feedbackColor.negative.pure;
  const warning = theme.feedbackColor.warning.dark;
  const grey = theme.neutralColor.low.dark;

  if (type === enOrderBumpStatus.ACTIVE) {
    return success;
  }

  if (type === enOrderBumpStatus.ERROR) {
    return error;
  }

  if (type === enOrderBumpStatus.WARNING) {
    return warning;
  }

  return grey;
};

const useStyle = createUseStyle(() => ({
  content: ({ type }: IProps) => {
    return {
      color: UseGetColor(type)
    };
  }
}));

const Status: React.FC<IProps> = props => {
  const styles = useStyle(props);

  return (
    <Container>
      <Typography size='xs' className={styles.content}>
        {props.text}
      </Typography>
    </Container>
  );
};

export default React.memo(Status);
